import React, { forwardRef } from "react";
import classNames from "classnames";
import Icon from "../../Icon";

export const PaginationItem = forwardRef(
  (
    {
      className,
      isDisabled,
      isActive,
      isPrev,
      isFirst,
      isNext,
      isLast,
      children,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <li
        ref={ref}
        className={classNames(
          "page-item",
          {
            disabled: isDisabled,
            active: isActive,
          },
          className
        )}
        {...props}
      >
        <span
          role="button"
          onClick={onClick}
          onKeyDown={onClick}
          className="page-link"
          tabIndex={isDisabled ? -1 : undefined}
          aria-disabled={isDisabled ? "true" : undefined}
          aria-label={
            (isPrev && "First Page") ||
            (isNext && "Last Page") ||
            `${children} page`
          }
        >
          {isPrev && <Icon iconName="ChevronFirst" width='13' height='13' />}
          {isFirst && <Icon iconName="ChevronLeft" width='13' height='13' />}
          {isNext && <Icon iconName="ChevronLast" width='13' height='13' />}
          {isLast && <Icon iconName="ChevronRight" width='13' height='13' />}
          {children}
        </span>
      </li>
    );
  }
);

const Pagination = forwardRef(
  ({ ariaLabel, className, children, size, ...props }, ref) => {
    return (
      <nav ref={ref} aria-label={ariaLabel} className={className} {...props}>
        <ul
          className={classNames(
            "pagination",
            { [`pagination-${size}`]: size },
            "m-0"
          )}
        >
          {children}
        </ul>
      </nav>
    );
  }
);

export default Pagination;
